// extracted by mini-css-extract-plugin
module.exports = {"mobileHeader":"styles-module--mobileHeader--LWits","title":"styles-module--title--2bMtv","overlay":"styles-module--overlay--21HdX","button":"styles-module--button--3-fgJ"};